import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Highcharts from "@material-ui/core/es/styles/withStyles";
import blue from "@material-ui/core/es/colors/blue";
import grey from "@material-ui/core/es/colors/grey";
import { withStyles } from '@material-ui/core/styles';
import {COLOR_chart_series_first_line} from "../../../common/CustomTheme/ThemeDefault/colors";

HighchartsMore(ReactHighcharts.Highcharts);

const styles = theme => ({
    card: {
        padding: '35px'
    }

});


var config =  {
    chart: {
        type: 'bar',

    },
    title: {
        text: 'Producao por hora do dia'
    },

    yAxis: {
        min:0,
        max: 24,
        title: {
            text: 'Hora'
        },
        labels: {
            enabled: true
        }
    },
    legend: {
        enabled: false
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    tooltip: {
        headerFormat: '<span style="font-size: 12px">Qtde OS: <b>{point.key}</b></span><br/>.',
       pointFormat: '<span style="color:{point.color}">●</span><b>{series.name}</b>  %: <b>{point.y}</b><br/>.'
    },


     series: []

}

function OperadoresDistributionOnEtapasHourStackedChart(props) {
    const { series, filter, classes, operador  } = props;

    let configs = [];


    console.log("series", series)

    if (series) {
        let hourSeriesArray = [];


        // Cria series de horarios produtivos e nao produticos
        let i=0;
        while (i<24) {


            // COLOR_chart_series_first_line
            hourSeriesArray.push({name: i+'h', data: [], color: COLOR_chart_series_first_line, index: 48- i*2 });
            hourSeriesArray.push({name: i+'h Não produtiva', data: [], color: '#dddddd', index: 47 - i*2 });
            i += 1;
        }

        //cria categorias e preenche horarios (series) com zero de producao
        let auxd = '';
        let auxh = 0;
        let auxpe = 0;
        let categories = [];
        series.map(i => {
            let d = new Date(i.Data).toISOString().slice(0, 10);

            if (d !== auxd || i.processoEtapaId !== auxpe) {
                auxd = d;
                auxpe = i.processoEtapaId;
                categories.push(auxd.slice(0, 10) + " " + i.Etapa);

                auxh = 0;
                while (auxh <= 23) {
                    hourSeriesArray[auxh * 2].data.push({y: 0, name: ''});
                    hourSeriesArray[auxh * 2 + 1].data.push({y:1, name: ''});
                    auxh += 1;
                }
            }

        })


        series.map( (i,ix) => {

            // buscar posicao do dia dentro das categorias
            let d = new Date(i.Data).toISOString().slice(0, 10) + " " + i.Etapa;
            var index = categories.indexOf(d);

            //
            hourSeriesArray[i.Hora * 2].data[index] = { y: i.PercTempo, name: i.QtdeOS.toString() };
            hourSeriesArray[i.Hora * 2 + 1].data[index] = { y: 1 - i.PercTempo , name: '' };
        });


            config = {
                ...config,

                title: {
                    text: 'Producao por hora do dia - ' + operador
                },

                xAxis: {
                    categories: categories,
                    title: {
                        text: 'Dia'
                    },
                    labels: {
                        format: '{value}',
                        enabled: true
                    }
                },

                series: hourSeriesArray

            }

    }

    const styles = { padding: '150px'}


    return (
        <Card title="laos" style={styles}>
           <ReactHighcharts config = {config} style={styles}>
                            </ReactHighcharts>

        </Card>
    )
}

export default (withStyles(styles))(OperadoresDistributionOnEtapasHourStackedChart)
